import {required} from "vuelidate/lib/validators";  
const strparam = {
    data() {
      return {  
        
        strparamData: { 
            Param: "",
            Value: "",
            Tip: null
          }, 
          FormDataType:{
            Value:{FieldName:"Value",Field:"input",FieldTitle:"Son Gün",FieldType:"text"},
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Value: { required },  
      }
 
  },
}
export default strparam